export { default } from './open-info-text';
